import { makeStyles } from '@material-ui/styles';

const styles = (theme) => ({
    centerWrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 24,
    },

    boxStyling: {
        backgroundColor: '#ffffff',
        padding: 24,
        borderRadius: 4,
        boxShadow: theme.customShadows.widget,
        display: 'flex',
        flexDirection: 'column',
        width: 600,
    },

    widgetContainer: {
        width: '100%',
    },

    descriptionBox: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        width: '95%',
        gap: 6,
    }
});

export default styles;
export const useStyles = makeStyles(styles);
